import { forwardRef, React, useEffect, useImperativeHandle, useRef, useState } from 'react';
import styled from 'styled-components';

import AccountInput from '../../../Component/AccountComponent/AccountInput.js';
import SignUpEmailInput from '../../../Component/AccountComponent/SignUpEmailInput.js';
import SocialSecurityInputWrapper from '../../../Component/AccountComponent/SocialSecurityInputWrapper.js';
import FetchModule from '../../Share/Network/FetchModule.js';

const SignUpInfo2 = forwardRef((props, ref) => {
	const { isOver } = props;

	const [socialSecurityClickCount, setSocialSecurityClickCount] = useState(0);
	const [phoneClickCount, setPhoneClickCount] = useState(0);
	const [emailClickCount, setEmailClickCount] = useState(0);
	const [isInvalidSocialSecurityNumber, setIsInvalidSocialSecurityNumber] = useState(false);
	const [isInvalidPhoneNumber, setIsInvalidPhoneNumber] = useState(false);
	const [isEmptyEmail, setIsEmptyEmail] = useState(true);
	const [isInvalidEmail, setIsInvalidEmail] = useState(false);
	const [isSuccessToSendEmail, setIsSuccessToSendEmail] = useState(false);
	const [isCheckEmail, setIsCheckEmail] = useState(false);	
	const [isClicked, setIsClicked] = useState(false);

	const IntervalRef = useRef(null);

	const TopLevelRef = useRef();
	const SocialSecurityRef = useRef();
	const PhoneRef = useRef();
	const EmailRef = useRef();
	const SocialSecurityPlanationRef = useRef();
	const PhonePlanationRef = useRef();
	const EmailPlanationRef = useRef();

	useImperativeHandle(ref, () => ({
		getSocialSecurityNumber: () => {
			return SocialSecurityRef.current.getValue();
		},
		getPhoneNumber: () => {
			return PhoneRef.current.getValue();
		},
		getEmail: () => {
			return EmailRef.current.getValue();
		},
		isBlankSocialSecurityNumber: () => {
			setIsInvalidSocialSecurityNumber(false);
			SocialSecurityRef.current.isSocialSecurityBlank();
			SocialSecurityPlanationRef.current.style.opacity = 1;
		},
		isInvalidSocialSecurityNumber: () => {
			setIsInvalidSocialSecurityNumber(true);
			SocialSecurityRef.current.isSocialSecurityBlank();
			SocialSecurityPlanationRef.current.style.opacity = 1;
		},
		isBlankPhoneNumber: () => {
			setIsInvalidPhoneNumber(false);
			PhoneRef.current.setDefaultPlaceholder('-를 제외하고 입력해주세요');
			PhoneRef.current.plusClickCount();
			PhonePlanationRef.current.style.opacity = 1;
		},
		isInvalidPhoneNumber: () => {
			setIsInvalidPhoneNumber(true);
			PhoneRef.current.setDefaultPlaceholder('-를 제외하고 입력해주세요');
			PhonePlanationRef.current.style.opacity = 1;
		},
		isBlankEmail: () => {
			setIsInvalidEmail(false);
			EmailRef.current.setDefaultPlaceholder('수신 가능한 이메일을 입력해주세요');
			EmailRef.current.plusClickCount();
			EmailPlanationRef.current.style.opacity = 1;
		},
		isInvalidEmail: () => {
			setIsInvalidEmail(true);
			EmailRef.current.setDefaultPlaceholder('수신 가능한 이메일을 입력해주세요');
			EmailPlanationRef.current.style.opacity = 1;
		},
		didNotCheckEmail: () => {
			setIsEmptyEmail(false);
			EmailRef.current.setDefaultPlaceholder('수신 가능한 이메일을 입력해주세요');
			EmailPlanationRef.current.style.opacity = 1;
		},
		getIsCheckEmail: () => {
			return isCheckEmail;
		},
		setOpacity: (val) => {
			TopLevelRef.current.style.opacity = val;
		},
		setLocation: (val) => {
			TopLevelRef.current.style.transform = `translateX(${val}%)`;
			setPhoneClickCount(0);
			setEmailClickCount(0);
			PhoneRef.current.reset('-를 제외하고 입력해주세요');
			EmailRef.current.reset('수신 가능한 이메일을 입력해주세요');
		}
	}));

	// input 애니메이션 및 상태 처리
	useEffect(() => {
		if (phoneClickCount === 0 && emailClickCount === 0 && socialSecurityClickCount === 0) return;

		if (PhoneRef.current.getValue() === '' && phoneClickCount > 0) {
			PhonePlanationRef.current.style.color = '#FF3131';
			PhonePlanationRef.current.style.opacity = 1;
		}
		else {
			PhonePlanationRef.current.style.opacity = 0;
		}

		if (EmailRef.current.getValue() === '' && emailClickCount > 0) {
			EmailPlanationRef.current.style.color = '#FF3131';
			EmailPlanationRef.current.style.opacity = 1;
		}
		else {
			EmailPlanationRef.current.style.opacity = 0;
		}

		if (SocialSecurityRef.current.getValue().length !== 14 && socialSecurityClickCount >= 0) {
			SocialSecurityPlanationRef.current.style.color = '#FF3131';
			SocialSecurityPlanationRef.current.style.opacity = 1;
		}
		else {
			SocialSecurityPlanationRef.current.style.opacity = 0;
		}

	}, [phoneClickCount, emailClickCount, socialSecurityClickCount])

	useEffect(() => {
		if (isSuccessToSendEmail) EmailPlanationRef.current.style.color = '#FF8B48';
		else EmailPlanationRef.current.style.color = '#FF3131';
	}, [isSuccessToSendEmail])
	
	useEffect(() => {
		if (!isClicked) {
			clearInterval(IntervalRef.current);
		}
	}, [isClicked])

	// email형식 확인 정규식
	function isEmail(asValue) {
		var regExp = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,6}$/i;

		return regExp.test(asValue);
	}

	function clickCountFn(className, clickCount) {
		if (className === 'PhoneInput') setPhoneClickCount(clickCount);
		else if (className === 'EmailInput') setEmailClickCount(clickCount);
		else if (className === 'SocialSecurityInput') setSocialSecurityClickCount(clickCount);
	}

	function emailAvailableCheck() {
		var email = EmailRef.current.getValue();

		if (email === '') {
			setIsEmptyEmail(true);
			EmailRef.current.setDefaultPlaceholder('수신 가능한 이메일을 입력해주세요');
			EmailPlanationRef.current.style.opacity = 1;
			return;
		}

		if (email === '' || !isEmail(email)) {
			setIsInvalidEmail(true);
			EmailRef.current.setDefaultPlaceholder('수신 가능한 이메일을 입력해주세요');
			EmailPlanationRef.current.style.opacity = 1;
			return;
		}

		EmailPlanationRef.current.style.opacity = 1;
		setIsSuccessToSendEmail(true);

		const fetchModule = new FetchModule();
		(
			async () => {
				const responseData = await fetchModule.postData('account/asp/available/' + email, 'POST');

				if (responseData.status === 200) {
					startInterval(email);
				}
				else if (responseData.status === 205) {
					alert("이미 사용중인 이메일 입니다.");
					setIsSuccessToSendEmail(false);
				}
				else {
					alert("이메일 전송에 실패하였습니다.\n다시 시도하여 주세요");
					setIsSuccessToSendEmail(false);
				}

			})();
	}
	
	function startInterval(email) {
		var count = 0;

		IntervalRef.current = setInterval(() => {
			
		const fetchModule = new FetchModule();
			(
				async () => {
					const responseData = await fetchModule.postData('account/asp/state/certification/' + email, 'POST');
					// console.log("ResponseData : " + responseData);
					count += 1;
					
					if (responseData.status === 200) {
						setIsCheckEmail(true);
						clearInterval(IntervalRef.current);
					}

					if (count === 180) clearInterval(IntervalRef.current);
				})
				();
		}, 1000)
	}

	return (
		<TopLevelWrapper ref={TopLevelRef} isOver={isOver}>
			<InputInfo isOver={isOver}>주민등록번호</InputInfo>
			<SocialSecurityInputWrapper ref={SocialSecurityRef} wrapperClassName='SocialSecurityInput' clickCountFn={clickCountFn} isOver={isOver}/>
			<AccountExplanation ref={SocialSecurityPlanationRef}>{isInvalidSocialSecurityNumber ? '주민번호가 올바르지 않습니다' : '필수항목을 입력해주세요'}</AccountExplanation>
			<InputInfo className='phone' isOver={isOver}>휴대전화 번호</InputInfo>
			<AccountInput ref={PhoneRef} className='PhoneInput' placeholder='-를 제외하고 입력해주세요' type='text' clickCountFn={clickCountFn} />
			<AccountExplanation ref={PhonePlanationRef}>{isInvalidPhoneNumber ? '휴대전화 번호가 올바르지 않습니다.' : '필수항목을 입력해주세요'}</AccountExplanation>
			<InputInfo isOver={isOver}>이메일 계정</InputInfo>
			<SignUpEmailInput ref={EmailRef} isClicked={isClicked} setIsClicked={setIsClicked} className='EmailInput' placeholder='수신 가능한 이메일을 입력해주세요' type='text' clickCountFn={clickCountFn} clickFn={emailAvailableCheck} text='계정확인' />
			{
				isSuccessToSendEmail ?
					<AccountExplanation ref={EmailPlanationRef}>{isCheckEmail ? '사용가능한 이메일입니다' : '이메일 수신함에서 인증 완료 버튼을 눌러주세요'}</AccountExplanation>
					:
					<AccountExplanation ref={EmailPlanationRef}>{isInvalidEmail ? '이메일을 정확하게 입력해주세요' : isEmptyEmail ? '필수항목을 입력해주세요' : '이메일 인증을 진행해 주세요'}</AccountExplanation>
			}
			{/* <AccountExplanation ref={EmailPlanationRef}>{isInvalidEmail ? '이메일을 정확하게 입력해주세요' : '필수항목을 입력해주세요'}</AccountExplanation> */}
		</TopLevelWrapper>
	)
})

export default SignUpInfo2;

const TopLevelWrapper = styled.div`
	position: absolute;
	display: flex;
	flex-direction: column; 

	justify-content: flex-start;

	// width: 369px;
	width: ${props => props.isOver ? `max(369px, 48.046875vw)` : `max(250px, 78.125vw)`};

	// margin-top: calc(139.5px - 19px); 106 - 18
	margin-top: ${props => props.isOver ? `120.5px` : `88px`};

	background-color: rgba(255, 255, 255, 1);

	opacity: 0;
	z-index: 1;

	transform: translateX(150%);

  transition: all 0.3s ease-in-out;
`;

const InputInfo = styled.p`
	font-family: NotoSansKR-Regular;
	font-size: 12px;

	// margin: 40px 0 0 0; 20.44 18
	// margin: ${props => props.className === 'phone' ? `4px 0 0 0` : `19px 0 0 0`};
	// margin-top: ${props => props.className === 'phone' ? `4px` : `19px`};
	margin-top: ${props => props.isOver ? props.className === 'phone' ? `0px` : `11px` : props.className === 'phone' ? `20.44px` : `18px`};
	margin-right: 0px;
	margin-bottom: 0px;
	margin-left: 0px;

	cursor: default;
`;

const AccountExplanation = styled.p`
	font-family: NotoSansKR-Regular;
	font-size: 12px;

	color: #FF3131;

	margin: 4px 0 0 0;

	opacity: 0;

  transition: all 0.5s ease-in-out;
`;